export default [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: function (e) {
      this.$router.push({
        path: '/',
      });
    },
  },
  {
    name: 'APP_LOGOUT',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Logout eseguito.',
      };
      this.$store.commit('clearJwt', this.$state);
      window.localStorage.clear();
      this.$router.replace({
        path: '/login',
      });
    },
  },
  {
    name: 'APP_UNAUTHORIZED',
    callback: function (e) {
      if (this.userData && this.userData.tipoAccesso === 'APP') {
        this.$store.commit('clearJwt', this.$state);
        window.localStorage.clear();
        this.$router.replace({
          path: '/DenyApp',
        });
      } else {
        this.$store.commit('clearJwt', this.$state);
        window.localStorage.clear();
        this.$router.replace({
          path: '/login',
        });
      }
    },
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: function (e) {},
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: function (e) {
      this.$router.push('/login');
      this.$message.error('Effettuare il login');
    },
  },
  {
    name: 'APP_BAD_REQUEST',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
    },
  },
  {
    name: 'APP_ACCESS_DENIED',
    // @error api response data
    callback: function (msg) {
      this.$message.error(msg);
      this.$router.push('/forbidden');
    },
  },
  {
    name: 'APP_RESOURCE_DELETED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    },
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    // @error api response data
    callback: function (msg) {
      this.$message.success(msg);
    },
  },
  {
    name: 'ASSOCIAZIONE_CREATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Associazione creata con successo.',
      };
    },
  },
  {
    name: 'ASSOCIAZIONE_MODIFICATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Associazione modificata con successo.',
      };
    },
  },
  {
    name: 'ASSOCIAZIONE_RIMOSSA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Associazione Rimossa con successo.',
      };
    },
  },
  {
    name: 'ASSOCIAZIONI_RIMOSSE',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Associazioni Rimosse con successo.',
      };
    },
  },
  {
    name: 'INDIRIZZO_ASSOCIAZIONE_RIMOSSO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Indirizzo Associazione eliminato.',
      };
    },
  },
  {
    name: 'CLASSIFICA_AGGIORNATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Classifica aggiornata.',
      };
    },
  },
  {
    name: 'IMPORT_EFFETTUATO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Import associati aggiornato.',
      };
    },
  },
  {
    name: 'IMMAGINE_AGGIORNATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Immagine aggiornata.',
      };
    },
  },
  {
    name: 'LOCANDINA_AGGIORNATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Locandina caricata.',
      };
    },
  },
  {
    name: 'PIAZZOLA_AGGIORNATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Piazzola caricata.',
      };
    },
  },
  {
    name: 'EVENTO_CREATO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Evento creato con successo.',
      };
    },
  },
  {
    name: 'EVENTO_MODIFICATO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Evento modificato con successo.',
      };
    },
  },
  {
    name: 'PARTECIPAZIONE_RIMOSSA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Partecipazione rimossa con successo.',
      };
    },
  },
  {
    name: 'PARTECIPAZIONI_RIMOSSE',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Partecipazioni rimosse con successo.',
      };
    },
  },
  {
    name: 'EVENTO_RIMOSSO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Evento rimosso con successo.',
      };
    },
  },
  {
    name: 'STORICO_RIMOSSO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Richiesta di rinnovo rimosso con successo.',
      };
    },
  },
  {
    name: 'ISCRIVI_CORRENTE',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: "Iscrizione all'anno corrente effettuata con successo.",
      };
    },
  },
  {
    name: 'STORICI_RIMOSSI',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Richieste di rinnovo rimosse con successo.',
      };
    },
  },
  {
    name: 'CLASSIFICA_RIMOSSA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Classifica rimossa con successo.',
      };
    },
  },
  {
    name: 'RANKING_RICALCOLATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'La Ranking verrà ricalcolata in background',
      };
    },
  },
  {
    name: 'PRENOTAZIONE_EFFETTUATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Prenotazione effettuata con successo.',
      };
    },
  },

  {
    name: 'ASSOCIATO_RIMOSSO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Associato rimosso con successo.',
      };
    },
  },
  {
    name: 'ASSOCIATO_MODIFICATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Associato modificato con successo.',
      };
    },
  },
  {
    name: 'ASSOCIATI_RIMOSSI',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Associati rimossi con successo.',
      };
    },
  },
  {
    name: 'ASSOCIATI_RICHIESTA_RINNOVO',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Richiesta rinnovo effettuata con successo.',
      };
    },
  },
  {
    name: 'ASSOCIATI_RICHIESTA_RIMOZIONE',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Richiesta rimozione rinnovo effettuata con successo.',
      };
    },
  },
  {
    name: 'NOTIFICA_AGGIUNTA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Notifica creata con successo.',
      };
    },
  },
  {
    name: 'NOTIFICA_CLASSIFICA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Notifica aggiunta con successo.',
      };
    },
  },
  {
    name: 'NOTIFICA_MODIFICATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Notifica modificata con successo.',
      };
    },
  },
  {
    name: 'NOTIFICA_ELIMINATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Notifica eliminata con successo.',
      };
    },
  },
  {
    name: 'NOTIFICA_INVIATA',
    callback: function (e) {
      this.snackbar = {
        show: true,
        color: 'green',
        text: 'Notifica inviata con successo.',
      };
    },
  },
];
